var _a;
export var RSS_ROUTE_TYPES = {
    BLOG: 'BLOG',
};
export var RSS_ROUTES = (_a = {},
    _a[RSS_ROUTE_TYPES.BLOG] = 'blog-feed.xml',
    _a);
export var BLOG_TPA_PAGE_ID = 'blog';
